export const MuiTableRow = {
    styleOverrides: {
        hover: {
            cursor: 'pointer'
        }
    }
};

//# sourceMappingURL=table-row.js.map